import ky from "ky";

import { jwt } from "../utils/index.js";

const { REACT_APP_MAIN_SERVER_URL } = process.env;

// Custom events for auth/navigation - allows API layer to trigger navigation without router access
const emitAuthRedirect = () => {
	window.dispatchEvent(new CustomEvent("ecoready:auth-redirect"));
};

const emitNotFoundRedirect = () => {
	window.dispatchEvent(new CustomEvent("ecoready:not-found-redirect"));
};

const rootApi = ky.extend({
	timeout: false,
	prefixUrl: `${REACT_APP_MAIN_SERVER_URL}/api`,
	retry: {
		statusCodes: [401, 408, 413, 429, 502, 503, 504],
		limit: 2,
		methods: ["get", "post", "put", "head", "delete", "options", "trace"],
	},
	hooks: {
		beforeRequest: [({ headers }) => {
			headers.set("x-access-token", jwt.getToken());
		}],
		beforeRetry: [
			async ({ request: { method }, error }) => {
				if (error?.response?.status === 401) {
					jwt.destroyToken();
					emitAuthRedirect();
				} else if (method === "POST") {
					throw error;
				}
			},
		],
		afterResponse: [
			(req, _, res) => {
				const { status } = res;

				if (status === 404 && !req.url.includes("/file/download/")) {
					emitNotFoundRedirect();
				}

				return res;
			},
		],
	},
});

export default rootApi;
export { emitAuthRedirect, emitNotFoundRedirect };
